import config from '@/config/index';

const BASE_API_PREFIX = 'smartcity-web/web/api';

function queryUserInfo(uid) {
  return `${config.HOST_API}${BASE_API_PREFIX}/${uid}`;
}
// 获取统计数据
function queryPagebarstat() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/pagebarstat`;
}
// 获取所有产品
function queryProjects() {
  return `${config.HOST_API}${BASE_API_PREFIX}/projects`;
}
// 获取所有产品
function queryProducts() {
  return `${config.HOST_API}${BASE_API_PREFIX}/products`;
}
// 获取推荐列表
function queryRecommendations() {
  return `${config.HOST_API}${BASE_API_PREFIX}/recommendations`;
}
// 获取广告列表-banner 推荐位
function queryAdvertises() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/advertises`;
}
// 获取平台视频列表
function queryPlatformVideos() {
  return `${config.HOST_API}${BASE_API_PREFIX}/platformVideos`;
}
// 获取所有专家
function querySpecialists() {
  return `${config.HOST_API}${BASE_API_PREFIX}/specialists`;
}
// 获取所有机构
function queryOrglist() {
  return `${config.HOST_API}${BASE_API_PREFIX}/orglist`;
}
// 获取所有推荐位
function querStatice() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/staticindexes?pc=1`;
}
export {
  queryUserInfo,
  queryProjects,
  queryProducts,
  queryRecommendations,
  queryAdvertises,
  queryPlatformVideos,
  querySpecialists,
  queryOrglist,
  queryPagebarstat,
  querStatice,
};
